import { api } from '../axiosClient';
import { PROJECTS_PATH } from './constants';
import type {
  CreateProjectPayload,
  CreateProjectResponse,
  MoveTaskPayload,
  ProjectDetailsResponse,
  ProjectResponse,
} from './projects.types';

export const postProject = (
  data: CreateProjectPayload,
): Promise<CreateProjectResponse> => api.post(PROJECTS_PATH, data);

export const getProjectDetails = (
  projectId: string,
): Promise<ProjectDetailsResponse> =>
  api.get(`${PROJECTS_PATH}/${projectId}/details`);

export const getProject = (id: number): Promise<ProjectResponse> =>
  api.get(`${PROJECTS_PATH}/${id}`);

export const deleteProject = (id: number): Promise<void> =>
  api.delete(`${PROJECTS_PATH}/${id}`);

export const moveTask = (
  projectId: number,
  taskId: number,
  data: MoveTaskPayload,
): Promise<void> =>
  api.patch(`${PROJECTS_PATH}/${projectId}/tasks/${taskId}/move`, data);

export const deleteTask = (projectId: number, taskId: number): Promise<void> =>
  api.delete(`${PROJECTS_PATH}/${projectId}/tasks/${taskId}`);
